import { render, staticRenderFns } from "./MutualizedDatacenter.vue?vue&type=template&id=4fa73cbf&"
import script from "./MutualizedDatacenter.vue?vue&type=script&lang=js&"
export * from "./MutualizedDatacenter.vue?vue&type=script&lang=js&"
import style0 from "./MutualizedDatacenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
